var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dumpling" }, [
    _c("div", {
      staticClass: "title",
      style: { backgroundImage: "url(" + _vm.dumpling.title.pictureUrl + ")" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }